import AirdomeAccess from '../../../base/forms/user/AirdomeAccess';

const airdomeAccess: AirdomeAccess = {
  header: 'User airdome access',
  submit: 'Confirm'
};

export default airdomeAccess;
